import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { TRADING_NAV_ITEMS, isNavItemActive } from './trading-nav-items';
import MarketStatusBadge from './MarketStatusBadge';
import IstClock from './IstClock';
import ThemeToggle from './ThemeToggle';
import './GlobalTradingNav.css';

/**
 * Sticky top navbar — full links on desktop; compact brand + status on mobile
 * (primary navigation moves to MobileBottomNav).
 */
export default function GlobalTradingNav() {
  const { pathname } = useLocation();

  return (
    <header className="global-trading-nav" role="navigation" aria-label="Trading screens">
      <div className="global-trading-nav-brand">
        <span className="global-trading-nav-logo">◆</span>
        <strong>Bharat Desk</strong>
        <span className="global-trading-nav-mobile-title">Trade</span>
      </div>
      <nav className="global-trading-nav-links" aria-label="Desktop trading screens">
        {TRADING_NAV_ITEMS.map((item) => (
          <Link
            key={item.key}
            to={item.path}
            className={`global-trading-nav-link${isNavItemActive(pathname, item) ? ' active' : ''}${item.highlight ? ' global-trading-nav-highlight' : ''}`}
          >
            <span className="global-trading-nav-icon" aria-hidden>{item.icon}</span>
            {item.label}
          </Link>
        ))}
      </nav>
      <div className="global-trading-nav-meta">
        <ThemeToggle compact />
        <IstClock />
        <MarketStatusBadge />
      </div>
    </header>
  );
}
